import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
export class LakehouseApiRequestFactory extends BaseAPIRequestFactory {
    async accessDataCatalog(projectId, workspaceId, catalogId, catalogAccessRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "accessDataCatalog", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "accessDataCatalog", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "accessDataCatalog", "catalogId");
        }
        if (catalogAccessRequest === null || catalogAccessRequest === undefined) {
            throw new RequiredError("LakehouseApi", "accessDataCatalog", "catalogAccessRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/access'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(catalogAccessRequest, "CatalogAccessRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async analyzeSqlQuery(projectId, workspaceId, analyzeSqlQueryRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "analyzeSqlQuery", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "analyzeSqlQuery", "workspaceId");
        }
        if (analyzeSqlQueryRequest === null || analyzeSqlQueryRequest === undefined) {
            throw new RequiredError("LakehouseApi", "analyzeSqlQuery", "analyzeSqlQueryRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-query/analyze'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(analyzeSqlQueryRequest, "AnalyzeSqlQueryRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async cancelSparkJob(projectId, workspaceId, sparkJobId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "cancelSparkJob", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "cancelSparkJob", "workspaceId");
        }
        if (sparkJobId === null || sparkJobId === undefined) {
            throw new RequiredError("LakehouseApi", "cancelSparkJob", "sparkJobId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-job/{sparkJobId}/cancel'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sparkJobId' + '}', encodeURIComponent(String(sparkJobId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createCredentialsProfile(projectId, workspaceId, createCredentialsProfileInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createCredentialsProfile", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createCredentialsProfile", "workspaceId");
        }
        if (createCredentialsProfileInput === null || createCredentialsProfileInput === undefined) {
            throw new RequiredError("LakehouseApi", "createCredentialsProfile", "createCredentialsProfileInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/credentials-profile'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createCredentialsProfileInput, "CreateCredentialsProfileInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createDashboard(projectId, workspaceId, createDashboardInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createDashboard", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createDashboard", "workspaceId");
        }
        if (createDashboardInput === null || createDashboardInput === undefined) {
            throw new RequiredError("LakehouseApi", "createDashboard", "createDashboardInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createDashboardInput, "CreateDashboardInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createDataCatalog(projectId, workspaceId, createDataCatalogInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createDataCatalog", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createDataCatalog", "workspaceId");
        }
        if (createDataCatalogInput === null || createDataCatalogInput === undefined) {
            throw new RequiredError("LakehouseApi", "createDataCatalog", "createDataCatalogInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createDataCatalogInput, "CreateDataCatalogInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createGraph(projectId, workspaceId, dashboardId, createGraphInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createGraph", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createGraph", "workspaceId");
        }
        if (dashboardId === null || dashboardId === undefined) {
            throw new RequiredError("LakehouseApi", "createGraph", "dashboardId");
        }
        if (createGraphInput === null || createGraphInput === undefined) {
            throw new RequiredError("LakehouseApi", "createGraph", "createGraphInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards/{dashboardId}/graphs'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'dashboardId' + '}', encodeURIComponent(String(dashboardId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createGraphInput, "CreateGraphInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createIngestionPipeline(projectId, workspaceId, createIngestionPipelineInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createIngestionPipeline", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createIngestionPipeline", "workspaceId");
        }
        if (createIngestionPipelineInput === null || createIngestionPipelineInput === undefined) {
            throw new RequiredError("LakehouseApi", "createIngestionPipeline", "createIngestionPipelineInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createIngestionPipelineInput, "CreateIngestionPipelineInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createJobTemplate(projectId, workspaceId, createJobTemplateInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createJobTemplate", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createJobTemplate", "workspaceId");
        }
        if (createJobTemplateInput === null || createJobTemplateInput === undefined) {
            throw new RequiredError("LakehouseApi", "createJobTemplate", "createJobTemplateInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/job-template'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createJobTemplateInput, "CreateJobTemplateInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createNotebook(projectId, workspaceId, createNotebookInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createNotebook", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createNotebook", "workspaceId");
        }
        if (createNotebookInput === null || createNotebookInput === undefined) {
            throw new RequiredError("LakehouseApi", "createNotebook", "createNotebookInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createNotebookInput, "CreateNotebookInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createSavedQuery(projectId, workspaceId, createSavedQueryInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createSavedQuery", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createSavedQuery", "workspaceId");
        }
        if (createSavedQueryInput === null || createSavedQueryInput === undefined) {
            throw new RequiredError("LakehouseApi", "createSavedQuery", "createSavedQueryInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/saved-query'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createSavedQueryInput, "CreateSavedQueryInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createSparkEngine(projectId, workspaceId, createSparkEngineInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createSparkEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createSparkEngine", "workspaceId");
        }
        if (createSparkEngineInput === null || createSparkEngineInput === undefined) {
            throw new RequiredError("LakehouseApi", "createSparkEngine", "createSparkEngineInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-engine'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createSparkEngineInput, "CreateSparkEngineInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createSqlEngine(projectId, workspaceId, createSqlEngineInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createSqlEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createSqlEngine", "workspaceId");
        }
        if (createSqlEngineInput === null || createSqlEngineInput === undefined) {
            throw new RequiredError("LakehouseApi", "createSqlEngine", "createSqlEngineInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-engine'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createSqlEngineInput, "CreateSqlEngineInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createWorkspaceAwsPrivateLink(projectId, workspaceId, createAwsPrivateLinkInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspaceAwsPrivateLink", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspaceAwsPrivateLink", "workspaceId");
        }
        if (createAwsPrivateLinkInput === null || createAwsPrivateLinkInput === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspaceAwsPrivateLink", "createAwsPrivateLinkInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/aws/private-link'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createAwsPrivateLinkInput, "CreateAwsPrivateLinkInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createWorkspaceAwsVpcPeering(projectId, workspaceId, createAwsVpcPeeringInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspaceAwsVpcPeering", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspaceAwsVpcPeering", "workspaceId");
        }
        if (createAwsVpcPeeringInput === null || createAwsVpcPeeringInput === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspaceAwsVpcPeering", "createAwsVpcPeeringInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/aws/vpc-peering'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createAwsVpcPeeringInput, "CreateAwsVpcPeeringInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createWorkspaceGcpVpcPeering(projectId, workspaceId, createGcpVpcPeeringInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspaceGcpVpcPeering", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspaceGcpVpcPeering", "workspaceId");
        }
        if (createGcpVpcPeeringInput === null || createGcpVpcPeeringInput === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspaceGcpVpcPeering", "createGcpVpcPeeringInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/gcp/vpc-peering'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createGcpVpcPeeringInput, "CreateGcpVpcPeeringInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createWorkspacePscEndpoint(projectId, workspaceId, createPscEndpointInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspacePscEndpoint", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspacePscEndpoint", "workspaceId");
        }
        if (createPscEndpointInput === null || createPscEndpointInput === undefined) {
            throw new RequiredError("LakehouseApi", "createWorkspacePscEndpoint", "createPscEndpointInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/gcp/private-service-connect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createPscEndpointInput, "CreatePscEndpointInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async createZeroEtlPolicy(projectId, workspaceId, createZeroEtlPolicyInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "createZeroEtlPolicy", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "createZeroEtlPolicy", "workspaceId");
        }
        if (createZeroEtlPolicyInput === null || createZeroEtlPolicyInput === undefined) {
            throw new RequiredError("LakehouseApi", "createZeroEtlPolicy", "createZeroEtlPolicyInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/zero-etl-policy'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createZeroEtlPolicyInput, "CreateZeroEtlPolicyInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteCredentialsProfile(projectId, workspaceId, credentialsProfileId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteCredentialsProfile", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteCredentialsProfile", "workspaceId");
        }
        if (credentialsProfileId === null || credentialsProfileId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteCredentialsProfile", "credentialsProfileId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/credentials-profile/{credentialsProfileId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'credentialsProfileId' + '}', encodeURIComponent(String(credentialsProfileId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteDashboard(projectId, workspaceId, dashboardId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteDashboard", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteDashboard", "workspaceId");
        }
        if (dashboardId === null || dashboardId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteDashboard", "dashboardId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards/{dashboardId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'dashboardId' + '}', encodeURIComponent(String(dashboardId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteDataCatalog(projectId, workspaceId, catalogId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteDataCatalog", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteDataCatalog", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteDataCatalog", "catalogId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteGraph(projectId, workspaceId, dashboardId, graphId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteGraph", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteGraph", "workspaceId");
        }
        if (dashboardId === null || dashboardId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteGraph", "dashboardId");
        }
        if (graphId === null || graphId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteGraph", "graphId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards/{dashboardId}/graphs/{graphId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'dashboardId' + '}', encodeURIComponent(String(dashboardId)))
            .replace('{' + 'graphId' + '}', encodeURIComponent(String(graphId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteIngestionPipeline(projectId, workspaceId, ingestionPipelineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteIngestionPipeline", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteIngestionPipeline", "workspaceId");
        }
        if (ingestionPipelineId === null || ingestionPipelineId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteIngestionPipeline", "ingestionPipelineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline/{ingestionPipelineId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'ingestionPipelineId' + '}', encodeURIComponent(String(ingestionPipelineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteJobTemplate(projectId, workspaceId, jobTemplateId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteJobTemplate", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteJobTemplate", "workspaceId");
        }
        if (jobTemplateId === null || jobTemplateId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteJobTemplate", "jobTemplateId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/job-template/{jobTemplateId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'jobTemplateId' + '}', encodeURIComponent(String(jobTemplateId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteNotebook(projectId, workspaceId, notebookId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteNotebook", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteNotebook", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteNotebook", "notebookId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteSavedQuery(projectId, workspaceId, savedQueryId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteSavedQuery", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteSavedQuery", "workspaceId");
        }
        if (savedQueryId === null || savedQueryId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteSavedQuery", "savedQueryId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/saved-query/{savedQueryId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'savedQueryId' + '}', encodeURIComponent(String(savedQueryId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteSparkEngine(projectId, workspaceId, sparkEngineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteSparkEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteSparkEngine", "workspaceId");
        }
        if (sparkEngineId === null || sparkEngineId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteSparkEngine", "sparkEngineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-engine/{sparkEngineId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sparkEngineId' + '}', encodeURIComponent(String(sparkEngineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteSqlEngine(projectId, workspaceId, sqlEngineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteSqlEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteSqlEngine", "workspaceId");
        }
        if (sqlEngineId === null || sqlEngineId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteSqlEngine", "sqlEngineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-engine/{sqlEngineId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sqlEngineId' + '}', encodeURIComponent(String(sqlEngineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteWorkspaceAwsPrivateLink(projectId, workspaceId, privateLinkId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspaceAwsPrivateLink", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspaceAwsPrivateLink", "workspaceId");
        }
        if (privateLinkId === null || privateLinkId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspaceAwsPrivateLink", "privateLinkId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/aws/private-link/{privateLinkId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'privateLinkId' + '}', encodeURIComponent(String(privateLinkId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteWorkspaceAwsVpcPeering(projectId, workspaceId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspaceAwsVpcPeering", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspaceAwsVpcPeering", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/aws/vpc-peering'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteWorkspaceGcpVpcPeering(projectId, workspaceId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspaceGcpVpcPeering", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspaceGcpVpcPeering", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/gcp/vpc-peering'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteWorkspacePscEndpoint(projectId, workspaceId, pscEndpointId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspacePscEndpoint", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspacePscEndpoint", "workspaceId");
        }
        if (pscEndpointId === null || pscEndpointId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteWorkspacePscEndpoint", "pscEndpointId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/gcp/private-service-connect/{pscEndpointId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'pscEndpointId' + '}', encodeURIComponent(String(pscEndpointId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteZeroEtlPolicy(projectId, workspaceId, zeroEtlPolicyId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteZeroEtlPolicy", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteZeroEtlPolicy", "workspaceId");
        }
        if (zeroEtlPolicyId === null || zeroEtlPolicyId === undefined) {
            throw new RequiredError("LakehouseApi", "deleteZeroEtlPolicy", "zeroEtlPolicyId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/zero-etl-policy/{zeroEtlPolicyId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'zeroEtlPolicyId' + '}', encodeURIComponent(String(zeroEtlPolicyId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async executeNotebookCode(projectId, workspaceId, notebookId, executeNotebookCodeInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "executeNotebookCode", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "executeNotebookCode", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "executeNotebookCode", "notebookId");
        }
        if (executeNotebookCodeInput === null || executeNotebookCodeInput === undefined) {
            throw new RequiredError("LakehouseApi", "executeNotebookCode", "executeNotebookCodeInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}/session/execute'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(executeNotebookCodeInput, "ExecuteNotebookCodeInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async explainSparkJob(projectId, workspaceId, sparkJobId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "explainSparkJob", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "explainSparkJob", "workspaceId");
        }
        if (sparkJobId === null || sparkJobId === undefined) {
            throw new RequiredError("LakehouseApi", "explainSparkJob", "sparkJobId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-job/{sparkJobId}/explain'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sparkJobId' + '}', encodeURIComponent(String(sparkJobId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getCredentialsProfile(projectId, workspaceId, credentialsProfileId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getCredentialsProfile", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getCredentialsProfile", "workspaceId");
        }
        if (credentialsProfileId === null || credentialsProfileId === undefined) {
            throw new RequiredError("LakehouseApi", "getCredentialsProfile", "credentialsProfileId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/credentials-profile/{credentialsProfileId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'credentialsProfileId' + '}', encodeURIComponent(String(credentialsProfileId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getDashboard(projectId, workspaceId, dashboardId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getDashboard", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getDashboard", "workspaceId");
        }
        if (dashboardId === null || dashboardId === undefined) {
            throw new RequiredError("LakehouseApi", "getDashboard", "dashboardId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards/{dashboardId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'dashboardId' + '}', encodeURIComponent(String(dashboardId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getDataCatalog(projectId, workspaceId, catalogId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getDataCatalog", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getDataCatalog", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getDataCatalog", "catalogId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getGraph(projectId, workspaceId, dashboardId, graphId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getGraph", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getGraph", "workspaceId");
        }
        if (dashboardId === null || dashboardId === undefined) {
            throw new RequiredError("LakehouseApi", "getGraph", "dashboardId");
        }
        if (graphId === null || graphId === undefined) {
            throw new RequiredError("LakehouseApi", "getGraph", "graphId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards/{dashboardId}/graphs/{graphId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'dashboardId' + '}', encodeURIComponent(String(dashboardId)))
            .replace('{' + 'graphId' + '}', encodeURIComponent(String(graphId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getIngestionPipeline(projectId, workspaceId, ingestionPipelineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipeline", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipeline", "workspaceId");
        }
        if (ingestionPipelineId === null || ingestionPipelineId === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipeline", "ingestionPipelineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline/{ingestionPipelineId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'ingestionPipelineId' + '}', encodeURIComponent(String(ingestionPipelineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getIngestionPipelineMetrics(projectId, workspaceId, ingestionPipelineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipelineMetrics", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipelineMetrics", "workspaceId");
        }
        if (ingestionPipelineId === null || ingestionPipelineId === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipelineMetrics", "ingestionPipelineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline/{ingestionPipelineId}/metrics'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'ingestionPipelineId' + '}', encodeURIComponent(String(ingestionPipelineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getIngestionPipelineMetricsRange(projectId, workspaceId, ingestionPipelineId, series, startTs, endTs, stepSeconds, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipelineMetricsRange", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipelineMetricsRange", "workspaceId");
        }
        if (ingestionPipelineId === null || ingestionPipelineId === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipelineMetricsRange", "ingestionPipelineId");
        }
        if (series === null || series === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipelineMetricsRange", "series");
        }
        if (startTs === null || startTs === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipelineMetricsRange", "startTs");
        }
        if (endTs === null || endTs === undefined) {
            throw new RequiredError("LakehouseApi", "getIngestionPipelineMetricsRange", "endTs");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline/{ingestionPipelineId}/metrics/range'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'ingestionPipelineId' + '}', encodeURIComponent(String(ingestionPipelineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (series !== undefined) {
            requestContext.setQueryParam("series", ObjectSerializer.serialize(series, "Array<string>", ""));
        }
        if (startTs !== undefined) {
            requestContext.setQueryParam("start_ts", ObjectSerializer.serialize(startTs, "number", ""));
        }
        if (endTs !== undefined) {
            requestContext.setQueryParam("end_ts", ObjectSerializer.serialize(endTs, "number", ""));
        }
        if (stepSeconds !== undefined) {
            requestContext.setQueryParam("step_seconds", ObjectSerializer.serialize(stepSeconds, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getJobTemplate(projectId, workspaceId, jobTemplateId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getJobTemplate", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getJobTemplate", "workspaceId");
        }
        if (jobTemplateId === null || jobTemplateId === undefined) {
            throw new RequiredError("LakehouseApi", "getJobTemplate", "jobTemplateId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/job-template/{jobTemplateId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'jobTemplateId' + '}', encodeURIComponent(String(jobTemplateId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getMaintenanceRun(projectId, workspaceId, runId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getMaintenanceRun", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getMaintenanceRun", "workspaceId");
        }
        if (runId === null || runId === undefined) {
            throw new RequiredError("LakehouseApi", "getMaintenanceRun", "runId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/maintenance-runs/{runId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'runId' + '}', encodeURIComponent(String(runId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getNotebook(projectId, workspaceId, notebookId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebook", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebook", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebook", "notebookId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getNotebookContent(projectId, workspaceId, notebookId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookContent", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookContent", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookContent", "notebookId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}/content'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getNotebookExecutionResult(projectId, workspaceId, notebookId, executionId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookExecutionResult", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookExecutionResult", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookExecutionResult", "notebookId");
        }
        if (executionId === null || executionId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookExecutionResult", "executionId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}/session/executions/{executionId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)))
            .replace('{' + 'executionId' + '}', encodeURIComponent(String(executionId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getNotebookSession(projectId, workspaceId, notebookId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookSession", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookSession", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "getNotebookSession", "notebookId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}/session'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSavedQuery(projectId, workspaceId, savedQueryId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getSavedQuery", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getSavedQuery", "workspaceId");
        }
        if (savedQueryId === null || savedQueryId === undefined) {
            throw new RequiredError("LakehouseApi", "getSavedQuery", "savedQueryId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/saved-query/{savedQueryId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'savedQueryId' + '}', encodeURIComponent(String(savedQueryId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSparkEngine(projectId, workspaceId, sparkEngineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getSparkEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getSparkEngine", "workspaceId");
        }
        if (sparkEngineId === null || sparkEngineId === undefined) {
            throw new RequiredError("LakehouseApi", "getSparkEngine", "sparkEngineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-engine/{sparkEngineId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sparkEngineId' + '}', encodeURIComponent(String(sparkEngineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSparkJob(projectId, workspaceId, sparkJobId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getSparkJob", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getSparkJob", "workspaceId");
        }
        if (sparkJobId === null || sparkJobId === undefined) {
            throw new RequiredError("LakehouseApi", "getSparkJob", "sparkJobId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-job/{sparkJobId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sparkJobId' + '}', encodeURIComponent(String(sparkJobId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSqlEngine(projectId, workspaceId, sqlEngineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getSqlEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getSqlEngine", "workspaceId");
        }
        if (sqlEngineId === null || sqlEngineId === undefined) {
            throw new RequiredError("LakehouseApi", "getSqlEngine", "sqlEngineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-engine/{sqlEngineId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sqlEngineId' + '}', encodeURIComponent(String(sqlEngineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSqlQueryExecution(projectId, workspaceId, sqlQueryExecutionId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getSqlQueryExecution", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getSqlQueryExecution", "workspaceId");
        }
        if (sqlQueryExecutionId === null || sqlQueryExecutionId === undefined) {
            throw new RequiredError("LakehouseApi", "getSqlQueryExecution", "sqlQueryExecutionId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-query-execution/{sqlQueryExecutionId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sqlQueryExecutionId' + '}', encodeURIComponent(String(sqlQueryExecutionId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSqlQueryExecutionResult(projectId, workspaceId, sqlQueryExecutionId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getSqlQueryExecutionResult", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getSqlQueryExecutionResult", "workspaceId");
        }
        if (sqlQueryExecutionId === null || sqlQueryExecutionId === undefined) {
            throw new RequiredError("LakehouseApi", "getSqlQueryExecutionResult", "sqlQueryExecutionId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-query-execution/{sqlQueryExecutionId}/result'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sqlQueryExecutionId' + '}', encodeURIComponent(String(sqlQueryExecutionId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityColumnInspect(projectId, workspaceId, catalogId, databaseName, tableName, columnName, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityColumnInspect", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityColumnInspect", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityColumnInspect", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityColumnInspect", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityColumnInspect", "tableName");
        }
        if (columnName === null || columnName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityColumnInspect", "columnName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/columns/{columnName}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)))
            .replace('{' + 'columnName' + '}', encodeURIComponent(String(columnName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityCompleteness(projectId, workspaceId, catalogId, databaseName, tableName, range, partition, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityCompleteness", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityCompleteness", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityCompleteness", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityCompleteness", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityCompleteness", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/completeness'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (range !== undefined) {
            requestContext.setQueryParam("range", ObjectSerializer.serialize(range, "'1h' | '6h' | '24h' | '7d'", ""));
        }
        if (partition !== undefined) {
            requestContext.setQueryParam("partition", ObjectSerializer.serialize(partition, "Array<string>", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityDistribution(projectId, workspaceId, catalogId, databaseName, tableName, range, partition, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistribution", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistribution", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistribution", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistribution", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistribution", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/distribution'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (range !== undefined) {
            requestContext.setQueryParam("range", ObjectSerializer.serialize(range, "'1h' | '6h' | '24h' | '7d'", ""));
        }
        if (partition !== undefined) {
            requestContext.setQueryParam("partition", ObjectSerializer.serialize(partition, "Array<string>", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityDistributionColumn(projectId, workspaceId, catalogId, databaseName, tableName, columnName, range, partition, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistributionColumn", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistributionColumn", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistributionColumn", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistributionColumn", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistributionColumn", "tableName");
        }
        if (columnName === null || columnName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityDistributionColumn", "columnName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/distribution/{columnName}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)))
            .replace('{' + 'columnName' + '}', encodeURIComponent(String(columnName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (range !== undefined) {
            requestContext.setQueryParam("range", ObjectSerializer.serialize(range, "string", ""));
        }
        if (partition !== undefined) {
            requestContext.setQueryParam("partition", ObjectSerializer.serialize(partition, "Array<string>", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityHeader(projectId, workspaceId, catalogId, databaseName, tableName, range, partition, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHeader", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHeader", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHeader", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHeader", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHeader", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/header'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (range !== undefined) {
            requestContext.setQueryParam("range", ObjectSerializer.serialize(range, "'1h' | '6h' | '24h' | '7d'", ""));
        }
        if (partition !== undefined) {
            requestContext.setQueryParam("partition", ObjectSerializer.serialize(partition, "Array<string>", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityHealthTrend(projectId, workspaceId, catalogId, databaseName, tableName, range, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHealthTrend", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHealthTrend", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHealthTrend", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHealthTrend", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityHealthTrend", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/health-trend'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (range !== undefined) {
            requestContext.setQueryParam("range", ObjectSerializer.serialize(range, "'1h' | '6h' | '24h' | '7d'", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityOverview(projectId, workspaceId, catalogId, databaseName, tableName, range, partition, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityOverview", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityOverview", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityOverview", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityOverview", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityOverview", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/overview'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (range !== undefined) {
            requestContext.setQueryParam("range", ObjectSerializer.serialize(range, "'1h' | '6h' | '24h' | '7d'", ""));
        }
        if (partition !== undefined) {
            requestContext.setQueryParam("partition", ObjectSerializer.serialize(partition, "Array<string>", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityPartitions(projectId, workspaceId, catalogId, databaseName, tableName, range, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityPartitions", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityPartitions", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityPartitions", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityPartitions", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityPartitions", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/partitions'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (range !== undefined) {
            requestContext.setQueryParam("range", ObjectSerializer.serialize(range, "string", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityQuarantine(projectId, workspaceId, catalogId, databaseName, tableName, range, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantine", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantine", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantine", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantine", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/quarantine'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (range !== undefined) {
            requestContext.setQueryParam("range", ObjectSerializer.serialize(range, "'1h' | '6h' | '24h' | '7d'", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityQuarantineBatch(projectId, workspaceId, catalogId, databaseName, tableName, batchId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantineBatch", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantineBatch", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantineBatch", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantineBatch", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantineBatch", "tableName");
        }
        if (batchId === null || batchId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityQuarantineBatch", "batchId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/quarantine/{batchId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)))
            .replace('{' + 'batchId' + '}', encodeURIComponent(String(batchId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualitySchemaChanges(projectId, workspaceId, catalogId, databaseName, tableName, range, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySchemaChanges", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySchemaChanges", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySchemaChanges", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySchemaChanges", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySchemaChanges", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/schema-changes'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (range !== undefined) {
            requestContext.setQueryParam("range", ObjectSerializer.serialize(range, "'1h' | '6h' | '24h' | '7d'", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualitySettings(projectId, workspaceId, catalogId, databaseName, tableName, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySettings", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySettings", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySettings", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySettings", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualitySettings", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/settings'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableDataQualityWidgetSeries(projectId, workspaceId, catalogId, databaseName, tableName, widgetKey, startTs, endTs, stepSeconds, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityWidgetSeries", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityWidgetSeries", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityWidgetSeries", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityWidgetSeries", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityWidgetSeries", "tableName");
        }
        if (widgetKey === null || widgetKey === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityWidgetSeries", "widgetKey");
        }
        if (startTs === null || startTs === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityWidgetSeries", "startTs");
        }
        if (endTs === null || endTs === undefined) {
            throw new RequiredError("LakehouseApi", "getTableDataQualityWidgetSeries", "endTs");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/widget-series'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (widgetKey !== undefined) {
            requestContext.setQueryParam("widgetKey", ObjectSerializer.serialize(widgetKey, "string", ""));
        }
        if (startTs !== undefined) {
            requestContext.setQueryParam("startTs", ObjectSerializer.serialize(startTs, "number", ""));
        }
        if (endTs !== undefined) {
            requestContext.setQueryParam("endTs", ObjectSerializer.serialize(endTs, "number", ""));
        }
        if (stepSeconds !== undefined) {
            requestContext.setQueryParam("stepSeconds", ObjectSerializer.serialize(stepSeconds, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableMaintenanceConfig(projectId, workspaceId, catalogId, databaseName, tableName, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceConfig", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceConfig", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceConfig", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceConfig", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceConfig", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/table-maintenance/{databaseName}/{tableName}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getTableMaintenanceRun(projectId, workspaceId, catalogId, databaseName, tableName, runId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceRun", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceRun", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceRun", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceRun", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceRun", "tableName");
        }
        if (runId === null || runId === undefined) {
            throw new RequiredError("LakehouseApi", "getTableMaintenanceRun", "runId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/maintenance-runs/{databaseName}/{tableName}/{runId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)))
            .replace('{' + 'runId' + '}', encodeURIComponent(String(runId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getWorkspace(projectId, workspaceId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspace", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspace", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getWorkspaceLoggingSettings(projectId, workspaceId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceLoggingSettings", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceLoggingSettings", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/logging'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getWorkspaceMaintenanceSettings(projectId, workspaceId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceMaintenanceSettings", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceMaintenanceSettings", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/maintenance'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getWorkspaceMetricsSettings(projectId, workspaceId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceMetricsSettings", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceMetricsSettings", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/metrics'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getWorkspaceNetworkingSettings(projectId, workspaceId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceNetworkingSettings", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceNetworkingSettings", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getWorkspaceStorageAccessConfiguration(projectId, workspaceId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceStorageAccessConfiguration", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getWorkspaceStorageAccessConfiguration", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/storage-access'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getZeroEtlPolicy(projectId, workspaceId, zeroEtlPolicyId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "getZeroEtlPolicy", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "getZeroEtlPolicy", "workspaceId");
        }
        if (zeroEtlPolicyId === null || zeroEtlPolicyId === undefined) {
            throw new RequiredError("LakehouseApi", "getZeroEtlPolicy", "zeroEtlPolicyId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/zero-etl-policy/{zeroEtlPolicyId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'zeroEtlPolicyId' + '}', encodeURIComponent(String(zeroEtlPolicyId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async interruptNotebookExecution(projectId, workspaceId, notebookId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "interruptNotebookExecution", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "interruptNotebookExecution", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "interruptNotebookExecution", "notebookId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}/session/interrupt'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listCredentialsProfiles(projectId, workspaceId, pageToken, pageSize, listCredentialsProfilesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listCredentialsProfiles", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listCredentialsProfiles", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/credentials-profile/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listCredentialsProfilesRequest, "ListCredentialsProfilesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listDashboards(projectId, workspaceId, pageToken, pageSize, listDashboardsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listDashboards", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listDashboards", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listDashboardsRequest, "ListDashboardsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listDataCatalogs(projectId, workspaceId, pageToken, pageSize, listDataCatalogsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listDataCatalogs", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listDataCatalogs", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listDataCatalogsRequest, "ListDataCatalogsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listGraphs(projectId, workspaceId, dashboardId, pageToken, pageSize, listGraphsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listGraphs", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listGraphs", "workspaceId");
        }
        if (dashboardId === null || dashboardId === undefined) {
            throw new RequiredError("LakehouseApi", "listGraphs", "dashboardId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards/{dashboardId}/graphs/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'dashboardId' + '}', encodeURIComponent(String(dashboardId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listGraphsRequest, "ListGraphsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listIngestionPipelines(projectId, workspaceId, pageToken, pageSize, listIngestionPipelinesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listIngestionPipelines", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listIngestionPipelines", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listIngestionPipelinesRequest, "ListIngestionPipelinesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listJobTemplates(projectId, workspaceId, pageToken, pageSize, listJobTemplatesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listJobTemplates", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listJobTemplates", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/job-template/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listJobTemplatesRequest, "ListJobTemplatesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listMaintenanceRuns(projectId, workspaceId, pageToken, pageSize, listMaintenanceRunsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listMaintenanceRuns", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listMaintenanceRuns", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/maintenance-runs/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listMaintenanceRunsRequest, "ListMaintenanceRunsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listNotebooks(projectId, workspaceId, pageToken, pageSize, listNotebooksRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listNotebooks", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listNotebooks", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listNotebooksRequest, "ListNotebooksRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listSavedQueries(projectId, workspaceId, pageToken, pageSize, listSavedQueriesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listSavedQueries", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listSavedQueries", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/saved-query/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listSavedQueriesRequest, "ListSavedQueriesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listSparkEngines(projectId, workspaceId, pageToken, pageSize, listSparkEnginesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listSparkEngines", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listSparkEngines", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-engine/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listSparkEnginesRequest, "ListSparkEnginesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listSparkJobs(projectId, workspaceId, pageToken, pageSize, listSparkJobsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listSparkJobs", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listSparkJobs", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-job/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listSparkJobsRequest, "ListSparkJobsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listSqlEngines(projectId, workspaceId, pageToken, pageSize, listSqlEnginesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listSqlEngines", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listSqlEngines", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-engine/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listSqlEnginesRequest, "ListSqlEnginesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listSqlQueryExecutions(projectId, workspaceId, pageToken, pageSize, listSqlQueryExecutionsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listSqlQueryExecutions", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listSqlQueryExecutions", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-query-execution/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listSqlQueryExecutionsRequest, "ListSqlQueryExecutionsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listTableMaintenanceRuns(projectId, workspaceId, catalogId, databaseName, tableName, pageToken, pageSize, listTableMaintenanceRunsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listTableMaintenanceRuns", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listTableMaintenanceRuns", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "listTableMaintenanceRuns", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "listTableMaintenanceRuns", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "listTableMaintenanceRuns", "tableName");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/maintenance-runs/{databaseName}/{tableName}/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listTableMaintenanceRunsRequest, "ListTableMaintenanceRunsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listWorkspaces(projectId, pageToken, pageSize, listWorkspacesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listWorkspaces", "projectId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listWorkspacesRequest, "ListWorkspacesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listZeroEtlPolicies(projectId, workspaceId, pageToken, pageSize, listZeroEtlPoliciesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "listZeroEtlPolicies", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "listZeroEtlPolicies", "workspaceId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/zero-etl-policy/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", ""));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listZeroEtlPoliciesRequest, "ListZeroEtlPoliciesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeBucketFile(projectId, workspaceId, bucketFileProbeRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeBucketFile", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeBucketFile", "workspaceId");
        }
        if (bucketFileProbeRequest === null || bucketFileProbeRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeBucketFile", "bucketFileProbeRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/bucket-file'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(bucketFileProbeRequest, "BucketFileProbeRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeBucketNotification(projectId, workspaceId, bucketNotificationProbeRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeBucketNotification", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeBucketNotification", "workspaceId");
        }
        if (bucketNotificationProbeRequest === null || bucketNotificationProbeRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeBucketNotification", "bucketNotificationProbeRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/bucket-notification'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(bucketNotificationProbeRequest, "BucketNotificationProbeRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeCatalogCheckName(projectId, workspaceId, catalogCheckNameRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCatalogCheckName", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCatalogCheckName", "workspaceId");
        }
        if (catalogCheckNameRequest === null || catalogCheckNameRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeCatalogCheckName", "catalogCheckNameRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/catalog/check-name'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(catalogCheckNameRequest, "CatalogCheckNameRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeCatalogListDatabases(projectId, workspaceId, catalogListDatabasesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCatalogListDatabases", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCatalogListDatabases", "workspaceId");
        }
        if (catalogListDatabasesRequest === null || catalogListDatabasesRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeCatalogListDatabases", "catalogListDatabasesRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/catalog/list-databases'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(catalogListDatabasesRequest, "CatalogListDatabasesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeCredentialsProfileAssume(projectId, workspaceId, credentialsProfileId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCredentialsProfileAssume", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCredentialsProfileAssume", "workspaceId");
        }
        if (credentialsProfileId === null || credentialsProfileId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCredentialsProfileAssume", "credentialsProfileId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/credentials-profile/{credentialsProfileId}/probe/assume'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'credentialsProfileId' + '}', encodeURIComponent(String(credentialsProfileId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeCredentialsProfileDataLakeWrite(projectId, workspaceId, credentialsProfileId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCredentialsProfileDataLakeWrite", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCredentialsProfileDataLakeWrite", "workspaceId");
        }
        if (credentialsProfileId === null || credentialsProfileId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCredentialsProfileDataLakeWrite", "credentialsProfileId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/credentials-profile/{credentialsProfileId}/probe/data-lake-write'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'credentialsProfileId' + '}', encodeURIComponent(String(credentialsProfileId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeCredentialsProfileFlinkStateWrite(projectId, workspaceId, credentialsProfileId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCredentialsProfileFlinkStateWrite", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCredentialsProfileFlinkStateWrite", "workspaceId");
        }
        if (credentialsProfileId === null || credentialsProfileId === undefined) {
            throw new RequiredError("LakehouseApi", "probeCredentialsProfileFlinkStateWrite", "credentialsProfileId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/credentials-profile/{credentialsProfileId}/probe/flink-state-write'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'credentialsProfileId' + '}', encodeURIComponent(String(credentialsProfileId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeGcsListPrefixes(projectId, workspaceId, gcsListPrefixesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeGcsListPrefixes", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeGcsListPrefixes", "workspaceId");
        }
        if (gcsListPrefixesRequest === null || gcsListPrefixesRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeGcsListPrefixes", "gcsListPrefixesRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/gcs/list-prefixes'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(gcsListPrefixesRequest, "GcsListPrefixesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeKafkaConnect(projectId, workspaceId, kafkaConnectProbeRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaConnect", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaConnect", "workspaceId");
        }
        if (kafkaConnectProbeRequest === null || kafkaConnectProbeRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaConnect", "kafkaConnectProbeRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/kafka/connect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(kafkaConnectProbeRequest, "KafkaConnectProbeRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeKafkaInferSchema(projectId, workspaceId, kafkaInferSchemaRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaInferSchema", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaInferSchema", "workspaceId");
        }
        if (kafkaInferSchemaRequest === null || kafkaInferSchemaRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaInferSchema", "kafkaInferSchemaRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/kafka/infer-schema'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(kafkaInferSchemaRequest, "KafkaInferSchemaRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeKafkaSample(projectId, workspaceId, kafkaSampleProbeRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaSample", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaSample", "workspaceId");
        }
        if (kafkaSampleProbeRequest === null || kafkaSampleProbeRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaSample", "kafkaSampleProbeRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/kafka/sample'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(kafkaSampleProbeRequest, "KafkaSampleProbeRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeKafkaSecret(projectId, workspaceId, kafkaSecretProbeRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaSecret", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaSecret", "workspaceId");
        }
        if (kafkaSecretProbeRequest === null || kafkaSecretProbeRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaSecret", "kafkaSecretProbeRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/kafka/secret'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(kafkaSecretProbeRequest, "KafkaSecretProbeRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeKafkaTopics(projectId, workspaceId, kafkaTopicsProbeRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaTopics", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaTopics", "workspaceId");
        }
        if (kafkaTopicsProbeRequest === null || kafkaTopicsProbeRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeKafkaTopics", "kafkaTopicsProbeRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/kafka/topics'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(kafkaTopicsProbeRequest, "KafkaTopicsProbeRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeS3DetectPartitions(projectId, workspaceId, s3DetectPartitionsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeS3DetectPartitions", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeS3DetectPartitions", "workspaceId");
        }
        if (s3DetectPartitionsRequest === null || s3DetectPartitionsRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeS3DetectPartitions", "s3DetectPartitionsRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/s3/detect-partitions'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(s3DetectPartitionsRequest, "S3DetectPartitionsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeS3ListPrefixes(projectId, workspaceId, s3ListPrefixesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeS3ListPrefixes", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeS3ListPrefixes", "workspaceId");
        }
        if (s3ListPrefixesRequest === null || s3ListPrefixesRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeS3ListPrefixes", "s3ListPrefixesRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/s3/list-prefixes'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(s3ListPrefixesRequest, "S3ListPrefixesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeS3SampleFile(projectId, workspaceId, s3SampleFileRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeS3SampleFile", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeS3SampleFile", "workspaceId");
        }
        if (s3SampleFileRequest === null || s3SampleFileRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeS3SampleFile", "s3SampleFileRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/s3/sample-file'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(s3SampleFileRequest, "S3SampleFileRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeSchemaRegistryConnect(projectId, workspaceId, schemaRegistryConnectRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistryConnect", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistryConnect", "workspaceId");
        }
        if (schemaRegistryConnectRequest === null || schemaRegistryConnectRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistryConnect", "schemaRegistryConnectRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/schema-registry/connect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(schemaRegistryConnectRequest, "SchemaRegistryConnectRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeSchemaRegistryResolveSubject(projectId, workspaceId, schemaRegistryResolveSubjectRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistryResolveSubject", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistryResolveSubject", "workspaceId");
        }
        if (schemaRegistryResolveSubjectRequest === null || schemaRegistryResolveSubjectRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistryResolveSubject", "schemaRegistryResolveSubjectRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/schema-registry/resolve-subject'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(schemaRegistryResolveSubjectRequest, "SchemaRegistryResolveSubjectRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeSchemaRegistrySchema(projectId, workspaceId, schemaRegistrySchemaRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistrySchema", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistrySchema", "workspaceId");
        }
        if (schemaRegistrySchemaRequest === null || schemaRegistrySchemaRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistrySchema", "schemaRegistrySchemaRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/schema-registry/schema'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(schemaRegistrySchemaRequest, "SchemaRegistrySchemaRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeSchemaRegistrySchemaById(projectId, workspaceId, schemaRegistrySchemaByIdRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistrySchemaById", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistrySchemaById", "workspaceId");
        }
        if (schemaRegistrySchemaByIdRequest === null || schemaRegistrySchemaByIdRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistrySchemaById", "schemaRegistrySchemaByIdRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/schema-registry/schema-by-id'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(schemaRegistrySchemaByIdRequest, "SchemaRegistrySchemaByIdRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async probeSchemaRegistrySubjects(projectId, workspaceId, schemaRegistrySubjectsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistrySubjects", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistrySubjects", "workspaceId");
        }
        if (schemaRegistrySubjectsRequest === null || schemaRegistrySubjectsRequest === undefined) {
            throw new RequiredError("LakehouseApi", "probeSchemaRegistrySubjects", "schemaRegistrySubjectsRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/probe/schema-registry/subjects'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(schemaRegistrySubjectsRequest, "SchemaRegistrySubjectsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async resetIngestionPipeline(projectId, workspaceId, ingestionPipelineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "resetIngestionPipeline", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "resetIngestionPipeline", "workspaceId");
        }
        if (ingestionPipelineId === null || ingestionPipelineId === undefined) {
            throw new RequiredError("LakehouseApi", "resetIngestionPipeline", "ingestionPipelineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline/{ingestionPipelineId}/reset'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'ingestionPipelineId' + '}', encodeURIComponent(String(ingestionPipelineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async saveNotebookContent(projectId, workspaceId, notebookId, saveNotebookContentRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "saveNotebookContent", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "saveNotebookContent", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "saveNotebookContent", "notebookId");
        }
        if (saveNotebookContentRequest === null || saveNotebookContentRequest === undefined) {
            throw new RequiredError("LakehouseApi", "saveNotebookContent", "saveNotebookContentRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}/content'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(saveNotebookContentRequest, "SaveNotebookContentRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async startIngestionPipeline(projectId, workspaceId, ingestionPipelineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "startIngestionPipeline", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "startIngestionPipeline", "workspaceId");
        }
        if (ingestionPipelineId === null || ingestionPipelineId === undefined) {
            throw new RequiredError("LakehouseApi", "startIngestionPipeline", "ingestionPipelineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline/{ingestionPipelineId}/start'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'ingestionPipelineId' + '}', encodeURIComponent(String(ingestionPipelineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async startNotebookSession(projectId, workspaceId, notebookId, startNotebookSessionInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "startNotebookSession", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "startNotebookSession", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "startNotebookSession", "notebookId");
        }
        if (startNotebookSessionInput === null || startNotebookSessionInput === undefined) {
            throw new RequiredError("LakehouseApi", "startNotebookSession", "startNotebookSessionInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}/session'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(startNotebookSessionInput, "StartNotebookSessionInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async startSparkEngine(projectId, workspaceId, sparkEngineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "startSparkEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "startSparkEngine", "workspaceId");
        }
        if (sparkEngineId === null || sparkEngineId === undefined) {
            throw new RequiredError("LakehouseApi", "startSparkEngine", "sparkEngineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-engine/{sparkEngineId}/start'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sparkEngineId' + '}', encodeURIComponent(String(sparkEngineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async startSparkJob(projectId, workspaceId, startSparkJobInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "startSparkJob", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "startSparkJob", "workspaceId");
        }
        if (startSparkJobInput === null || startSparkJobInput === undefined) {
            throw new RequiredError("LakehouseApi", "startSparkJob", "startSparkJobInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-job'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(startSparkJobInput, "StartSparkJobInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async startSqlEngine(projectId, workspaceId, sqlEngineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "startSqlEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "startSqlEngine", "workspaceId");
        }
        if (sqlEngineId === null || sqlEngineId === undefined) {
            throw new RequiredError("LakehouseApi", "startSqlEngine", "sqlEngineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-engine/{sqlEngineId}/start'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sqlEngineId' + '}', encodeURIComponent(String(sqlEngineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async startSqlQueryExecution(projectId, workspaceId, startSqlQueryExecutionInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "startSqlQueryExecution", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "startSqlQueryExecution", "workspaceId");
        }
        if (startSqlQueryExecutionInput === null || startSqlQueryExecutionInput === undefined) {
            throw new RequiredError("LakehouseApi", "startSqlQueryExecution", "startSqlQueryExecutionInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-query-execution'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(startSqlQueryExecutionInput, "StartSqlQueryExecutionInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async stopIngestionPipeline(projectId, workspaceId, ingestionPipelineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "stopIngestionPipeline", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "stopIngestionPipeline", "workspaceId");
        }
        if (ingestionPipelineId === null || ingestionPipelineId === undefined) {
            throw new RequiredError("LakehouseApi", "stopIngestionPipeline", "ingestionPipelineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline/{ingestionPipelineId}/stop'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'ingestionPipelineId' + '}', encodeURIComponent(String(ingestionPipelineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async stopNotebookSession(projectId, workspaceId, notebookId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "stopNotebookSession", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "stopNotebookSession", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "stopNotebookSession", "notebookId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}/session'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async stopSparkEngine(projectId, workspaceId, sparkEngineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "stopSparkEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "stopSparkEngine", "workspaceId");
        }
        if (sparkEngineId === null || sparkEngineId === undefined) {
            throw new RequiredError("LakehouseApi", "stopSparkEngine", "sparkEngineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/spark-engine/{sparkEngineId}/stop'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sparkEngineId' + '}', encodeURIComponent(String(sparkEngineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async stopSqlEngine(projectId, workspaceId, sqlEngineId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "stopSqlEngine", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "stopSqlEngine", "workspaceId");
        }
        if (sqlEngineId === null || sqlEngineId === undefined) {
            throw new RequiredError("LakehouseApi", "stopSqlEngine", "sqlEngineId");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/sql-engine/{sqlEngineId}/stop'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'sqlEngineId' + '}', encodeURIComponent(String(sqlEngineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateCredentialsProfile(projectId, workspaceId, credentialsProfileId, updateCredentialsProfileInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateCredentialsProfile", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateCredentialsProfile", "workspaceId");
        }
        if (credentialsProfileId === null || credentialsProfileId === undefined) {
            throw new RequiredError("LakehouseApi", "updateCredentialsProfile", "credentialsProfileId");
        }
        if (updateCredentialsProfileInput === null || updateCredentialsProfileInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateCredentialsProfile", "updateCredentialsProfileInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/credentials-profile/{credentialsProfileId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'credentialsProfileId' + '}', encodeURIComponent(String(credentialsProfileId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateCredentialsProfileInput, "UpdateCredentialsProfileInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateDashboard(projectId, workspaceId, dashboardId, updateDashboardInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateDashboard", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateDashboard", "workspaceId");
        }
        if (dashboardId === null || dashboardId === undefined) {
            throw new RequiredError("LakehouseApi", "updateDashboard", "dashboardId");
        }
        if (updateDashboardInput === null || updateDashboardInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateDashboard", "updateDashboardInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards/{dashboardId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'dashboardId' + '}', encodeURIComponent(String(dashboardId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateDashboardInput, "UpdateDashboardInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateGraph(projectId, workspaceId, dashboardId, graphId, updateGraphInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateGraph", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateGraph", "workspaceId");
        }
        if (dashboardId === null || dashboardId === undefined) {
            throw new RequiredError("LakehouseApi", "updateGraph", "dashboardId");
        }
        if (graphId === null || graphId === undefined) {
            throw new RequiredError("LakehouseApi", "updateGraph", "graphId");
        }
        if (updateGraphInput === null || updateGraphInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateGraph", "updateGraphInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/dashboards/{dashboardId}/graphs/{graphId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'dashboardId' + '}', encodeURIComponent(String(dashboardId)))
            .replace('{' + 'graphId' + '}', encodeURIComponent(String(graphId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateGraphInput, "UpdateGraphInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateIngestionPipeline(projectId, workspaceId, ingestionPipelineId, updateIngestionPipelineInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateIngestionPipeline", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateIngestionPipeline", "workspaceId");
        }
        if (ingestionPipelineId === null || ingestionPipelineId === undefined) {
            throw new RequiredError("LakehouseApi", "updateIngestionPipeline", "ingestionPipelineId");
        }
        if (updateIngestionPipelineInput === null || updateIngestionPipelineInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateIngestionPipeline", "updateIngestionPipelineInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/ingestion-pipeline/{ingestionPipelineId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'ingestionPipelineId' + '}', encodeURIComponent(String(ingestionPipelineId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateIngestionPipelineInput, "UpdateIngestionPipelineInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateJobTemplate(projectId, workspaceId, jobTemplateId, updateJobTemplateInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateJobTemplate", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateJobTemplate", "workspaceId");
        }
        if (jobTemplateId === null || jobTemplateId === undefined) {
            throw new RequiredError("LakehouseApi", "updateJobTemplate", "jobTemplateId");
        }
        if (updateJobTemplateInput === null || updateJobTemplateInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateJobTemplate", "updateJobTemplateInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/job-template/{jobTemplateId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'jobTemplateId' + '}', encodeURIComponent(String(jobTemplateId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateJobTemplateInput, "UpdateJobTemplateInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateNotebook(projectId, workspaceId, notebookId, updateNotebookInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateNotebook", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateNotebook", "workspaceId");
        }
        if (notebookId === null || notebookId === undefined) {
            throw new RequiredError("LakehouseApi", "updateNotebook", "notebookId");
        }
        if (updateNotebookInput === null || updateNotebookInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateNotebook", "updateNotebookInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/notebook/{notebookId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'notebookId' + '}', encodeURIComponent(String(notebookId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateNotebookInput, "UpdateNotebookInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateSavedQuery(projectId, workspaceId, savedQueryId, updateSavedQueryInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateSavedQuery", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateSavedQuery", "workspaceId");
        }
        if (savedQueryId === null || savedQueryId === undefined) {
            throw new RequiredError("LakehouseApi", "updateSavedQuery", "savedQueryId");
        }
        if (updateSavedQueryInput === null || updateSavedQueryInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateSavedQuery", "updateSavedQueryInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/saved-query/{savedQueryId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'savedQueryId' + '}', encodeURIComponent(String(savedQueryId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateSavedQueryInput, "UpdateSavedQueryInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateTableDataQualitySettings(projectId, workspaceId, catalogId, databaseName, tableName, updateTableDataQualitySettingsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableDataQualitySettings", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableDataQualitySettings", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableDataQualitySettings", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableDataQualitySettings", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableDataQualitySettings", "tableName");
        }
        if (updateTableDataQualitySettingsRequest === null || updateTableDataQualitySettingsRequest === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableDataQualitySettings", "updateTableDataQualitySettingsRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/data-quality/{databaseName}/{tableName}/settings'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateTableDataQualitySettingsRequest, "UpdateTableDataQualitySettingsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateTableMaintenanceConfig(projectId, workspaceId, catalogId, databaseName, tableName, updateTableMaintenanceConfigInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableMaintenanceConfig", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableMaintenanceConfig", "workspaceId");
        }
        if (catalogId === null || catalogId === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableMaintenanceConfig", "catalogId");
        }
        if (databaseName === null || databaseName === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableMaintenanceConfig", "databaseName");
        }
        if (tableName === null || tableName === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableMaintenanceConfig", "tableName");
        }
        if (updateTableMaintenanceConfigInput === null || updateTableMaintenanceConfigInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateTableMaintenanceConfig", "updateTableMaintenanceConfigInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/catalog/{catalogId}/table-maintenance/{databaseName}/{tableName}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'catalogId' + '}', encodeURIComponent(String(catalogId)))
            .replace('{' + 'databaseName' + '}', encodeURIComponent(String(databaseName)))
            .replace('{' + 'tableName' + '}', encodeURIComponent(String(tableName)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateTableMaintenanceConfigInput, "UpdateTableMaintenanceConfigInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateWorkspaceAwsPrivateLink(projectId, workspaceId, privateLinkId, updateAwsPrivateLinkInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceAwsPrivateLink", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceAwsPrivateLink", "workspaceId");
        }
        if (privateLinkId === null || privateLinkId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceAwsPrivateLink", "privateLinkId");
        }
        if (updateAwsPrivateLinkInput === null || updateAwsPrivateLinkInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceAwsPrivateLink", "updateAwsPrivateLinkInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/aws/private-link/{privateLinkId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'privateLinkId' + '}', encodeURIComponent(String(privateLinkId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateAwsPrivateLinkInput, "UpdateAwsPrivateLinkInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateWorkspaceLoggingSettings(projectId, workspaceId, updateWorkspaceLoggingSettingsInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceLoggingSettings", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceLoggingSettings", "workspaceId");
        }
        if (updateWorkspaceLoggingSettingsInput === null || updateWorkspaceLoggingSettingsInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceLoggingSettings", "updateWorkspaceLoggingSettingsInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/logging'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateWorkspaceLoggingSettingsInput, "UpdateWorkspaceLoggingSettingsInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateWorkspaceMaintenanceSettings(projectId, workspaceId, updateWorkspaceMaintenanceSettingsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceMaintenanceSettings", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceMaintenanceSettings", "workspaceId");
        }
        if (updateWorkspaceMaintenanceSettingsRequest === null || updateWorkspaceMaintenanceSettingsRequest === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceMaintenanceSettings", "updateWorkspaceMaintenanceSettingsRequest");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/maintenance'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateWorkspaceMaintenanceSettingsRequest, "UpdateWorkspaceMaintenanceSettingsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateWorkspaceMetricsSettings(projectId, workspaceId, updateWorkspaceMetricsSettingsInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceMetricsSettings", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceMetricsSettings", "workspaceId");
        }
        if (updateWorkspaceMetricsSettingsInput === null || updateWorkspaceMetricsSettingsInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceMetricsSettings", "updateWorkspaceMetricsSettingsInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/metrics'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateWorkspaceMetricsSettingsInput, "UpdateWorkspaceMetricsSettingsInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateWorkspacePscEndpoint(projectId, workspaceId, pscEndpointId, updatePscEndpointInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspacePscEndpoint", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspacePscEndpoint", "workspaceId");
        }
        if (pscEndpointId === null || pscEndpointId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspacePscEndpoint", "pscEndpointId");
        }
        if (updatePscEndpointInput === null || updatePscEndpointInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspacePscEndpoint", "updatePscEndpointInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/networking/gcp/private-service-connect/{pscEndpointId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'pscEndpointId' + '}', encodeURIComponent(String(pscEndpointId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updatePscEndpointInput, "UpdatePscEndpointInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateWorkspaceStorageAccessConfiguration(projectId, workspaceId, updateWorkspaceStorageAccessConfigurationInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceStorageAccessConfiguration", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceStorageAccessConfiguration", "workspaceId");
        }
        if (updateWorkspaceStorageAccessConfigurationInput === null || updateWorkspaceStorageAccessConfigurationInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateWorkspaceStorageAccessConfiguration", "updateWorkspaceStorageAccessConfigurationInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/settings/storage-access'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateWorkspaceStorageAccessConfigurationInput, "UpdateWorkspaceStorageAccessConfigurationInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateZeroEtlPolicy(projectId, workspaceId, zeroEtlPolicyId, updateZeroEtlPolicyInput, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("LakehouseApi", "updateZeroEtlPolicy", "projectId");
        }
        if (workspaceId === null || workspaceId === undefined) {
            throw new RequiredError("LakehouseApi", "updateZeroEtlPolicy", "workspaceId");
        }
        if (zeroEtlPolicyId === null || zeroEtlPolicyId === undefined) {
            throw new RequiredError("LakehouseApi", "updateZeroEtlPolicy", "zeroEtlPolicyId");
        }
        if (updateZeroEtlPolicyInput === null || updateZeroEtlPolicyInput === undefined) {
            throw new RequiredError("LakehouseApi", "updateZeroEtlPolicy", "updateZeroEtlPolicyInput");
        }
        const localVarPath = '/projects/{projectId}/lakehouse/workspace/{workspaceId}/zero-etl-policy/{zeroEtlPolicyId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'workspaceId' + '}', encodeURIComponent(String(workspaceId)))
            .replace('{' + 'zeroEtlPolicyId' + '}', encodeURIComponent(String(zeroEtlPolicyId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateZeroEtlPolicyInput, "UpdateZeroEtlPolicyInput", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class LakehouseApiResponseProcessor {
    async accessDataCatalogWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "CatalogAccessResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid action or unsupported catalog type", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Catalog or connector not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async analyzeSqlQueryWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "string", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Query execution is not yet complete", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "SQL query execution not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async cancelSparkJobWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SparkJob", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Spark job not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createCredentialsProfileWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "CredentialsProfile", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Credentials profile with this name already exists", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createDashboardWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Dashboard", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Dashboard with this name already exists", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createDataCatalogWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "DataCatalog", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Catalog with this name or external ID already exists", undefined, response.headers, response);
        }
        if (isCodeInRange("422", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Missing required properties for the catalog type", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createGraphWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "DashboardGraph", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Dashboard not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createIngestionPipelineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "IngestionPipeline", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Ingestion pipeline already exists", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createJobTemplateWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "JobTemplate", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Job template already exists", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createNotebookWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Notebook", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Notebook with same name already exists", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createSavedQueryWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SavedQuery", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Saved query with this name already exists", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createSparkEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SparkEngine", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Spark engine already exists", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createSqlEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SqlEngine", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "SQL engine already exists", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createWorkspaceAwsPrivateLinkWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "AwsPrivateLink", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createWorkspaceAwsVpcPeeringWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "AwsVpcPeering", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "VPC peering already exists for this workspace", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createWorkspaceGcpVpcPeeringWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GcpVpcPeering", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "VPC peering already exists for this workspace", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createWorkspacePscEndpointWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "PscEndpoint", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async createZeroEtlPolicyWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ZeroEtlPolicy", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Zero-ETL policy already exists", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteCredentialsProfileWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Credentials profile not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteDashboardWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Dashboard not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteDataCatalogWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Data catalog not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteGraphWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Graph not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteIngestionPipelineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "IngestionPipeline", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Ingestion pipeline not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Operation already in progress", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteJobTemplateWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Job template not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteNotebookWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Notebook not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteSavedQueryWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Saved query not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteSparkEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Spark engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteSqlEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "SQL engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteWorkspaceAwsPrivateLinkWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "PrivateLink endpoint not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteWorkspaceAwsVpcPeeringWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "No active VPC peering found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteWorkspaceGcpVpcPeeringWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "No active VPC peering found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteWorkspacePscEndpointWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "PSC endpoint not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteZeroEtlPolicyWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Zero-ETL policy not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async executeNotebookCodeWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "NotebookExecutionResult", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "No active session", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async explainSparkJobWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "string", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Job is not in a terminal status or has no Spark application ID", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Spark job not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getCredentialsProfileWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "CredentialsProfile", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Credentials profile not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getDashboardWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "DashboardWithGraphs", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Dashboard not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getDataCatalogWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "DataCatalog", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Data catalog not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getGraphWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "DashboardGraph", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Graph not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getIngestionPipelineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "IngestionPipeline", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Ingestion pipeline not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getIngestionPipelineMetricsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "IngestionPipelineMetrics", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Ingestion pipeline not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getIngestionPipelineMetricsRangeWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "IngestionPipelineMetricsRange", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Ingestion pipeline not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getJobTemplateWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "JobTemplate", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Job template not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getMaintenanceRunWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "MaintenanceRun", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getNotebookWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Notebook", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Notebook not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getNotebookContentWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetNotebookContent200Response", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Notebook not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getNotebookExecutionResultWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "NotebookExecutionResult", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getNotebookSessionWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "NotebookSession", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "No active session", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSavedQueryWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SavedQuery", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Saved query not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSparkEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SparkEngine", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Spark engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSparkJobWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SparkJob", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Spark job not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSqlEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SqlEngine", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "SQL engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSqlQueryExecutionWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SqlQueryExecution", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "SQL query execution not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSqlQueryExecutionResultWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SqlQueryExecutionResult", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Query execution has not completed or failed", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "SQL query execution not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityColumnInspectWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityColumnInspectResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityCompletenessWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityCompletenessResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityDistributionWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityDistributionResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityDistributionColumnWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityDistributionColumnResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityHeaderWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityHeaderResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityHealthTrendWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityHealthTrendResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityOverviewWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityOverviewResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityPartitionsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityPartitionsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityQuarantineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityQuarantineResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityQuarantineBatchWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityQuarantineBatchResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualitySchemaChangesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualitySchemaChangesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualitySettingsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualitySettingsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableDataQualityWidgetSeriesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualityWidgetSeriesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableMaintenanceConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "TableMaintenanceConfig", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getTableMaintenanceRunWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "MaintenanceRun", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getWorkspaceWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Workspace", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Workspace not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getWorkspaceLoggingSettingsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "WorkspaceLoggingSettings", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getWorkspaceMaintenanceSettingsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "WorkspaceMaintenanceSettings", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getWorkspaceMetricsSettingsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "WorkspaceMetricsSettings", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getWorkspaceNetworkingSettingsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "WorkspaceNetworkingSettings", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getWorkspaceStorageAccessConfigurationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "WorkspaceStorageAccessConfiguration", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getZeroEtlPolicyWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ZeroEtlPolicy", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Zero-ETL policy not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async interruptNotebookExecutionWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "No active session", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listCredentialsProfilesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListCredentialsProfilesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listDashboardsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListDashboardsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listDataCatalogsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListDataCatalogsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listGraphsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListGraphsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listIngestionPipelinesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListIngestionPipelinesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listJobTemplatesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListJobTemplatesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listMaintenanceRunsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListMaintenanceRunsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listNotebooksWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListNotebooksResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listSavedQueriesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListSavedQueriesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listSparkEnginesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListSparkEnginesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listSparkJobsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListSparkJobsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listSqlEnginesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListSqlEnginesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listSqlQueryExecutionsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListSqlQueryExecutionsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listTableMaintenanceRunsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListTableMaintenanceRunsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listWorkspacesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListWorkspacesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listZeroEtlPoliciesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListZeroEtlPoliciesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeBucketFileWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "BucketFileProbeResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeBucketNotificationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "BucketNotificationProbeResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeCatalogCheckNameWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "CatalogCheckNameResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeCatalogListDatabasesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "CatalogListDatabasesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeCredentialsProfileAssumeWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "CredentialsProbeAssumeResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Credentials profile not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeCredentialsProfileDataLakeWriteWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "CredentialsProbeWriteResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Credentials profile not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeCredentialsProfileFlinkStateWriteWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "CredentialsProbeWriteResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Credentials profile not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeGcsListPrefixesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GcsListPrefixesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeKafkaConnectWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "KafkaConnectProbeResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeKafkaInferSchemaWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "KafkaInferSchemaResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeKafkaSampleWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "KafkaSampleProbeResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeKafkaSecretWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "KafkaSecretProbeResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeKafkaTopicsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "KafkaTopicsProbeResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeS3DetectPartitionsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "S3DetectPartitionsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeS3ListPrefixesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "S3ListPrefixesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeS3SampleFileWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "S3SampleFileResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeSchemaRegistryConnectWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SchemaRegistryConnectResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeSchemaRegistryResolveSubjectWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SchemaRegistryResolveSubjectResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeSchemaRegistrySchemaWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SchemaRegistrySchemaResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeSchemaRegistrySchemaByIdWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SchemaRegistrySchemaResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async probeSchemaRegistrySubjectsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SchemaRegistrySubjectsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async resetIngestionPipelineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "IngestionPipeline", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Ingestion pipeline not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Operation already in progress (or pipeline not in STOPPED/CREATE_FAILED)", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async saveNotebookContentWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Notebook not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async startIngestionPipelineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "IngestionPipeline", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Ingestion pipeline not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Operation already in progress", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async startNotebookSessionWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "NotebookSession", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Engine not started or session already active", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async startSparkEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SparkEngine", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Spark engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async startSparkJobWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SparkJob", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Spark engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async startSqlEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SqlEngine", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "SQL engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async startSqlQueryExecutionWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SqlQueryExecution", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "SQL engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async stopIngestionPipelineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "IngestionPipeline", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Ingestion pipeline not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Operation already in progress", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async stopNotebookSessionWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "NotebookSession", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "No active session", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async stopSparkEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SparkEngine", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Spark engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async stopSqlEngineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SqlEngine", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "SQL engine not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateCredentialsProfileWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "CredentialsProfile", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Credentials profile not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateDashboardWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Dashboard", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Dashboard not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateGraphWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "DashboardGraph", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Graph not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateIngestionPipelineWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "IngestionPipeline", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request — missing required source properties or validation failure", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Ingestion pipeline not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Operation in progress or invalid state for update", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateJobTemplateWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "JobTemplate", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Job template not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateNotebookWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Notebook", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Notebook not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateSavedQueryWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SavedQuery", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Saved query not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateTableDataQualitySettingsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "GetTableDataQualitySettingsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateTableMaintenanceConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "TableMaintenanceConfig", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateWorkspaceAwsPrivateLinkWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "AwsPrivateLink", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "PrivateLink endpoint not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateWorkspaceLoggingSettingsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "WorkspaceLoggingSettings", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateWorkspaceMaintenanceSettingsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "WorkspaceMaintenanceSettings", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateWorkspaceMetricsSettingsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "WorkspaceMetricsSettings", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateWorkspacePscEndpointWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "PscEndpoint", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "PSC endpoint not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateWorkspaceStorageAccessConfigurationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "WorkspaceStorageAccessConfiguration", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateZeroEtlPolicyWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ZeroEtlPolicy", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Zero-ETL policy not found", undefined, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
